/** @format */

export interface SubjectDetailSchemaInput {
	subjectName: string;
	subjectDescription: string | undefined;
	pageUrl: string;
	ogImage?: string;
	datePublished?: string;
}

export const createSubjectDetailSchema = ({
	subjectName,
	subjectDescription,
	pageUrl,
	ogImage = 'https://www.llb360.com/og-law-subjects.webp',
	datePublished = '2024-01-01',
}: SubjectDetailSchemaInput) => ({
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'Organization',
			'@id': 'https://www.llb360.com/#organization',
			name: 'LLB360',
			url: 'https://www.llb360.com',
			logo: 'https://www.llb360.com/logo.png',
		},
		{
			'@type': 'EducationalCourse',
			name: subjectName,
			description: subjectDescription,
			provider: {
				'@type': 'Organization',
				name: 'LLB360',
				sameAs: 'https://www.llb360.com',
			},
		},
		{
			'@type': 'Article',
			headline: `${subjectName} for LLB Students`,
			description: subjectDescription,
			author: {
				'@type': 'Organization',
				name: 'LLB360',
			},
			publisher: {
				'@type': 'Organization',
				name: 'LLB360',
				logo: {
					'@type': 'ImageObject',
					url: 'https://www.llb360.com/logo.png',
				},
			},
			mainEntityOfPage: {
				'@type': 'WebPage',
				'@id': pageUrl,
			},
			image: ogImage,
			datePublished,
			dateModified: new Date().toISOString(),
		},
	],
});
